import React, { Component } from 'react'

export default class Pagination extends Component {
  // constructor(){
  //   super()
  //   // console.log(props,this.props);
  //   // let {currPage,onPrev, onNext} = props
    
  // }

  // onNext = ()=>{
  //   console.log("pagi pagi");
  //   this.setState({
  //     currPage:this.state.currPage+1
  //   })
    
  // }
  render() {
    // console.log(this.props);
    return (
      <div className='flex justify-center cursor-pointer m-4 space-x-0.1'>
        <div className='border-1 text-blue-400 border-blue-400 p-2 border-r-0 rounded-l-xl' onClick={this.props.onPrev}>Previous</div>
        {/* {
          this.state.parr.map((value)=>(
            ))
          } */}
        <div className='border-1 text-blue-400 border-blue-400 p-2 border-r-0'>{this.props.currPage}</div>  
        <div className='border-1 text-blue-400 border-blue-400 p-2 rounded-r-xl' onClick={this.props.onNext}>Next</div>
      </div>
    )
  }
}
